import { memo } from "react";
import { ExpensesWidgetProps } from "./types";

import { useTranslate } from "helpers";
import { Tabs } from "ui/components/Tabs";
import ExpensesSearchTab from "./components/ExpensesSearchTab/ExpensesSearchTab";
import ExpensesStatsTab from "./components/ExpensesStatsTab/ExpensesStatsTab";


const ExpensesWidget: React.FC<ExpensesWidgetProps> = () => {
  const { t } = useTranslate();

  return (
    <Tabs
      tabs={[
        {
          label: t("admin.dashboard.widget.expenses.tab.stats.title"),
          content: <ExpensesStatsTab />,
        },
        {
          label: t("admin.dashboard.widget.expenses.tab.search.title"),
          content: <ExpensesSearchTab />,
        },
      ]}
    />
  );
};

export default memo(ExpensesWidget);
